/**
 * The material a machine draws with (`onboarding-3d-plan-edit-build-floors`, R2.5, R2.6). The shared
 * `MACHINE_MATERIAL` by default. Each renderer, the live twin's and every 3D plan's, provides its own
 * patched copy through its `MachineLookScope` (`spec-onboarding-persistent-scene-model-look`, R3).
 * The 3D plan's Build floors provides further copies of that: a faint floor's machines draw translucent with
 * no depth writes, and the selected floor's draw in the transparent pass so the floors' draw order,
 * not their heights, decides what is on top. The placeholder box reads it too.
 */
import { createContext } from 'react';
import type { Material } from 'three';
import { MACHINE_MATERIAL } from '@repo/ui';

export const MachineMaterialContext = createContext<Material>(MACHINE_MATERIAL);

/**
 * The draw order every group of a machine takes (R2.5). three.js sorts the transparent pass by the
 * nearest group's `renderOrder` first, and each nested group resets it, so a host's ordered group
 * around the machines reaches a mesh only if the machine's own groups carry it. 0 by default, a
 * group's own default, so the live twin draws exactly as before; the 3D plan's Build floors gives
 * each floor's machines their layer's order, so a faint floor drawn later never covers them.
 */
export const MachineRenderOrderContext = createContext(0);
